import { DatabaseOperationEnum } from '../../../enums/database-operation.enum';
import { TransformDate } from '../../../decorators/transform-date.decorator';
import { ApiRequestFilters } from '../../../types/api-request-filters';
import { ActivityEventTypeEnum } from '../../activity/enums/activity-event-type.enum';

/**
 * Audit log filters
 */
export class AuditLogFilters extends ApiRequestFilters {
  /**
   * Database operation values
   */
  operations?: DatabaseOperationEnum[];

  /**
   * Activity event type values
   */
  eventTypes?: ActivityEventTypeEnum[];

  /**
   * Occurred at from
   */
  @TransformDate()
  occurredAtFrom?: Date;

  /**
   * Occurred at to
   */
  @TransformDate()
  occurredAtTo?: Date;
}
